import sample from "./sample-userstatus"
export default sample